/**
 * usePartnerBenefits - list, get del Club de Beneficios.
 */

import { useQuery } from '@tanstack/react-query';
import { partnerBenefitsApi } from '../../infrastructure/repositories/http/PartnerBenefitsHttpRepository';
import type { PartnerBenefitsListParams } from '../../application/dto/PartnerBenefitDTO';

export const partnerBenefitsKeys = {
  all: ['partner-benefits'] as const,
  list: (params?: PartnerBenefitsListParams) =>
    [...partnerBenefitsKeys.all, 'list', params] as const,
  detail: (id: string) => [...partnerBenefitsKeys.all, id] as const,
};

export function usePartnerBenefits(params?: PartnerBenefitsListParams) {
  return useQuery({
    queryKey: partnerBenefitsKeys.list(params),
    queryFn: () => partnerBenefitsApi.list(params),
    staleTime: 5 * 60 * 1000, // 5 min — catálogo cambia poco
  });
}

export function usePartnerBenefit(id: string | undefined | null) {
  return useQuery({
    queryKey: partnerBenefitsKeys.detail(id ?? ''),
    queryFn: () => partnerBenefitsApi.get(id!),
    enabled: !!id,
  });
}
